// Each report declares the permission it requires (Reports."Permission",
// surfaced per-leaf by /report/category). The Reports tab itself is shown to
// anyone holding ANY of the three report permissions — see Navbar.tsx, which
// deliberately ORs them so commission-only and business-only users aren't
// locked out of the tab entirely. That means the catalog the tab renders still
// has to be pruned down to what the user actually holds, or a commission-only
// user sees and can click every client and business report in the tree.
//
// Fails closed: a report leaf with no Permission is dropped, not shown. Every
// report hangs off one of the two root categories ('selected', 'all-clients'),
// both covered by the permission backfill, so a missing value means the
// report's requirement is unknown — not that it is unrestricted.
//
// Categories survive only if at least one descendant report does, at any depth:
// the real catalog nests 2-3 levels in places (all-clients -> commission-reports
// -> commission-due-reports -> CommissionDueReport), so this recurses rather
// than assuming a flat category -> reports shape. Same branch/leaf test the
// sidebar and ReportSelector already use — a node is a report if it has a
// ReportCode, otherwise it's a category.
export const filterReportsByPermission = (
  nodes: any[] = [],
  hasPermission: (permission: string) => boolean,
): any[] =>
  nodes.reduce((acc: any[], node: any) => {
    if (node?.ReportCode) {
      if (node.Permission && hasPermission(node.Permission)) acc.push(node);
      return acc;
    }

    const children = filterReportsByPermission(node?.children, hasPermission);
    if (children.length > 0) acc.push({ ...node, children });
    return acc;
  }, []);
